module.exports = __webpack_public_path__ + "media/images/story_ogp_image/story_publication-0b9f3128db168e19056da128235f4ac9.png";